module.exports = __webpack_public_path__ + "lp/img/question_icon-blue.c437e940.svg";